module.exports = __webpack_public_path__ + "static/mint-f156e82158af762f0a028b6e359367e6.svg";